"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosReturnInspectInputSchema = exports.APosReturnCreateInputSchema = exports.APosReturnSchema = exports.APosReturnItemSchema = exports.APosRestockDispositionSchema = exports.APosQualityGradeSchema = exports.APosReturnReasonSchema = exports.APosReturnStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosReturnStatusSchema = zod_1.z.enum([
    'pending', 'approved', 'inspected', 'restocked', 'rejected', 'disposed',
]);
exports.APosReturnReasonSchema = zod_1.z.enum([
    'defective', 'wrong_item', 'not_as_described', 'changed_mind',
    'expired', 'damaged_in_transit', 'other',
]);
exports.APosQualityGradeSchema = zod_1.z.enum(['A', 'B', 'C', 'D']);
exports.APosRestockDispositionSchema = zod_1.z.enum([
    'restock_full_price', 'restock_discounted', 'return_to_supplier', 'dispose', 'donate',
]);
exports.APosReturnItemSchema = zod_1.z.object({
    lineId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    quantity: zod_1.z.number().int().positive(),
    originalUnitPrice: zod_1.z.number().nonnegative(),
    originalLineTotal: zod_1.z.number().nonnegative(),
    refundUnitPrice: zod_1.z.number().nonnegative(),
    restockingFee: zod_1.z.number().nonnegative().default(0),
    refundLineTotal: zod_1.z.number().nonnegative(),
    reason: exports.APosReturnReasonSchema,
    reasonNotes: zod_1.z.string().max(500).optional(),
    qualityGrade: exports.APosQualityGradeSchema.optional(),
    inspectionNotes: zod_1.z.string().max(500).optional(),
    disposition: exports.APosRestockDispositionSchema.optional(),
    batchId: zod_1.z.string().optional(),
    serialNumbers: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.APosReturnSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    returnId: id_schema_1.EntityIdSchema,
    returnNumber: zod_1.z.string().min(1),
    locationId: id_schema_1.EntityIdSchema,
    orderId: id_schema_1.EntityIdSchema,
    orderNumber: zod_1.z.string().min(1),
    customerId: id_schema_1.EntityIdSchema.optional(),
    customerName: zod_1.z.string().optional(),
    customerPhone: zod_1.z.string().optional(),
    items: zod_1.z.array(exports.APosReturnItemSchema).min(1),
    subtotalRefund: zod_1.z.number().nonnegative(),
    totalRestockingFees: zod_1.z.number().nonnegative().default(0),
    totalRefund: zod_1.z.number().nonnegative(),
    refundMethod: zod_1.z.enum(['original_payment', 'store_credit', 'cash', 'card']),
    refundReference: zod_1.z.string().optional(),
    refundProcessedAt: zod_1.z.number().optional(),
    status: exports.APosReturnStatusSchema.default('pending'),
    approvedBy: id_schema_1.EntityIdSchema.optional(),
    approvedAt: zod_1.z.number().optional(),
    inspectedBy: id_schema_1.EntityIdSchema.optional(),
    inspectedAt: zod_1.z.number().optional(),
    restockedAt: zod_1.z.number().optional(),
    restockedBy: id_schema_1.EntityIdSchema.optional(),
    rejectedAt: zod_1.z.number().optional(),
    rejectedBy: id_schema_1.EntityIdSchema.optional(),
    rejectionReason: zod_1.z.string().max(500).optional(),
    notes: zod_1.z.string().max(2000).optional(),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosReturnCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    orderId: id_schema_1.EntityIdSchema,
    customerId: id_schema_1.EntityIdSchema.optional(),
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        productId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().min(1),
        sku: zod_1.z.string().optional(),
        quantity: zod_1.z.number().int().positive(),
        originalUnitPrice: zod_1.z.number().nonnegative(),
        reason: exports.APosReturnReasonSchema,
        reasonNotes: zod_1.z.string().max(500).optional(),
        batchId: zod_1.z.string().optional(),
        serialNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    })).min(1),
    refundMethod: zod_1.z.enum(['original_payment', 'store_credit', 'cash', 'card']),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosReturnInspectInputSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        lineId: id_schema_1.EntityIdSchema,
        qualityGrade: exports.APosQualityGradeSchema,
        disposition: exports.APosRestockDispositionSchema,
        restockingFee: zod_1.z.number().nonnegative().optional(),
        inspectionNotes: zod_1.z.string().max(500).optional(),
    })).min(1),
});
//# sourceMappingURL=return.schema.js.map